import { ViewModel, View, ObservableArray } from "binder"
import moment from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty, translate } from "src/common/utilities";
import { AccountGatewaySelectorViewModel } from "src/erp/arap/rawData/accountGatewaySelector-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { ServerSideDataLoader, PaginationInfo } from "uicomponents";
import { PosDeviceSelectorViewModel } from "../posDeviceManipulation/posDeviceManipulation-viewModel";
import { PosGatewayManipulationView } from "./posGatewayManipulation-view"

export class PosGatewayManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return translate("posGatewayManipulation-viewModel.poseAccountManagement", {});
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.posGateway = ObservableArray.create<posGateway>();
        this.loader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);
        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new PosGatewayManipulationView();
    }
    public getTypeId(): string {
        return "VM-6B9CB034-DDCA-435B-9194-E4E08203EA13"
    }
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;
    public set posGateway(v: ObservableArray<posGateway>) { this._posGateway = v; } public get posGateway(): ObservableArray<posGateway> { return this._posGateway; } private _posGateway: ObservableArray<posGateway>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    refresh() {
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/FinancialServices/GetAllPosGateway', {
                FilteringInformation: filteringInformation
            });
            let rowNumber = 1;
            this.posGateway.update(...result.PosGateway.map(q => {
                let r = new posGateway(this);
                r.id = q.Id;
                r.rowNumber = rowNumber++;
                r.bankId = q.BankId;
                r.bankName = q.BankName;
                r.districtId = q.DistrictId;
                r.districtName = q.DistrictName;
                r.accountId = q.AccountId;
                r.accountName = q.AccountName;
                r.posDeviceId = q.PosDeviceId;
                r.posDeviceName = q.PosDeviceName;
                r.createDate = moment.utc(q.CreateDate);
                r.removeDate = q.RemoveDate == null ? null : moment.utc(q.RemoveDate);
                r.canInvalidate = q.RemoveDate == null;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }
    async requestPosGatewayCreation() {
        let editor = new posGatewayEditor(this, new InsertServerUpdater());
        let resultCode = await this.showPopup(editor);
        if (resultCode == 'done') {
            this.loader.refresh();
        }
    }

    async posGatewayUpdater(posGateway: posGateway) {
        let editor = new posGatewayEditor(this, new UpdateServerUpdater());
        posGateway.cloneTo(editor);
        let resultCode = await this.showPopup(editor);
        if (resultCode == 'done') {
            this.loader.refresh();
        }
    }

    async accept(id: any) {
        try {
            this.isLoading = true;
            await ServerConnection.callServer('/Complex/ArapRawDataServices/InvalidateGateway', {
                GatewayId: id
            });
            await this.messageBoxConfirmSuccess(translate("posGatewayManipulation-viewModel.deactivatedPoseAccount", {}), translate("posGatewayManipulation-viewModel.successfulOperation", {}));
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(translate("posGatewayManipulation-viewModel.operationErorr", {}), translate("posGatewayManipulation-viewModel.error", {}));
        } finally {
            this.isLoading = false;
            this.loader.refresh();
        }
    }
}

export class posGateway extends ViewModel {

    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: PosGatewayManipulationViewModel) {
        super(parent);
        this._typedParent = parent;

    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber; } private _rowNumber: number;
    public set createDate(v: moment.Moment) { this._createDate = v; } public get createDate(): moment.Moment { return this._createDate; } private _createDate: moment.Moment;
    public set removeDate(v: moment.Moment) { this._removeDate = v; } public get removeDate(): moment.Moment { return this._removeDate; } private _removeDate: moment.Moment;
    public set canInvalidate(v: boolean) { this._canInvalidate = v; } public get canInvalidate(): boolean { return this._canInvalidate; } private _canInvalidate: boolean;

    public set accountId(v: string) { this._accountId = v; } public get accountId(): string { return this._accountId; } private _accountId: string;
    public set accountName(v: string) { this._accountName = v; } public get accountName(): string { return this._accountName; } private _accountName: string;
    public set districtId(v: string) { this._districtId = v; } public get districtId(): string { return this._districtId; } private _districtId: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName; } private _districtName: string;
    public set bankName(v: string) { this._bankName = v; } public get bankName(): string { return this._bankName; } private _bankName: string;
    public set bankId(v: string) { this._bankId = v; } public get bankId(): string { return this._bankId; } private _bankId: string;
    public set posDeviceId(v: string) { this._posDeviceId = v; } public get posDeviceId(): string { return this._posDeviceId; } private _posDeviceId: string;
    public set posDeviceName(v: string) { this._posDeviceName = v; } public get posDeviceName(): string { return this._posDeviceName; } private _posDeviceName: string;

    private _typedParent: PosGatewayManipulationViewModel;

    cloneTo(posGateway: posGateway) {
        posGateway.id = this.id;
        posGateway.setAccount(this.accountId, this.accountName);
        posGateway.setPosDevice(this.posDeviceId, this.posDeviceName);
    }

    async edit() {
        this._typedParent.posGatewayUpdater(this);
    }

    setAccount(id: string, name: string) {
        this.accountId = id;
        this.accountName = name;
    }
    getAccountId() {
        return this.accountId;
    }

    setPosDevice(id: string, name: string) {
        this.posDeviceId = id;
        this.posDeviceName = name;
    }
    getPosDeviceId() {
        return this.posDeviceId;
    }

    async inactivePosGateway(): Promise<void> {
        if (this.canInvalidate) {
            let result: string;
            result = await this.messageBoxWarningYesNo(translate("posGatewayManipulation-viewModel.sureQuestion", {}), translate("posGatewayManipulation-viewModel.deactivateCard", {}));
            if (result == 'yes') {
                this._typedParent.accept(this.id);
            }
        }
    }

}

interface IServerUpdater {
    execute(posGateway: posGateway): Promise<void>;
    getSuccessMessage(): string;
}

class InsertServerUpdater implements IServerUpdater {
    getSuccessMessage(): string {
        return translate("posGatewayManipulation-viewModel.successfullyRegistered", {});
    }
    async execute(posGateway: posGateway): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/ArapRawDataServices/CreatePosGateway', {
            AccountId: posGateway.getAccountId(),
            PosDeviceId: posGateway.getPosDeviceId(),
        });
        if (result.IsSuccessful == false) {
            throw "new Error";
        }
    }
}

class UpdateServerUpdater implements IServerUpdater {
    getSuccessMessage(): string {
        return translate("posGatewayManipulation-viewModel.successfullyUpdated", {});
    }
    async execute(posGateway: posGateway): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/ArapRawDataServices/UpdatePosGateway', {
            Id: posGateway.id,
            AccountId: posGateway.getAccountId(),
            PosDeviceId: posGateway.getPosDeviceId(),
        });
        if (result.IsSuccessful == false) {
            throw "new Error";
        }
    }
}

export class posGatewayEditor extends posGateway implements IPopup {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }

    constructor(parent: PosGatewayManipulationViewModel, serverUpdater: IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
        this.accountSelector = new AccountGatewaySelectorViewModel(this);
        this.posDeviceSelector = new PosDeviceSelectorViewModel(this);
    }
    closePopup(resultCode: string = null) {
    }

    private _serverUpdater: IServerUpdater;
    public set accountSelector(v: AccountGatewaySelectorViewModel) { this._accountSelector = v; } public get accountSelector(): AccountGatewaySelectorViewModel { return this._accountSelector; } private _accountSelector: AccountGatewaySelectorViewModel;
    public set posDeviceSelector(v: PosDeviceSelectorViewModel) { this._posDeviceSelector = v; } public get posDeviceSelector(): PosDeviceSelectorViewModel { return this._posDeviceSelector; } private _posDeviceSelector: PosDeviceSelectorViewModel;

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.getPosDeviceId())) {
            result.push(translate("posGatewayManipulation-viewModel.poseError", {}));
        }
        if (stringIsNullOrEmpty(this.getAccountId())) {
            result.push(translate("posGatewayManipulation-viewModel.accountError", {}));
        }
        return result;
    }

    setPosDevice(id: string, name: string) {
        this.posDeviceSelector.selectById(id);
    }

    getPosDeviceId() {
        return this.posDeviceSelector.selectedItem?.id;
    }

    setAccount(id: string, name: string) {
        this.accountSelector.selectById(id);
    }

    getAccountId() {
        return this.accountSelector.selectedItem?.accountId;
    }

    async save() {
        try {
            let verificationResult = this.verify();
            if (verificationResult.length > 0) {
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage, translate("posGatewayManipulation-viewModel.notPossibleToRegister", {}));
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(), translate("posGatewayManipulation-viewModel.successfulOperation", {}));
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(translate("posGatewayManipulation-viewModel.operationErorr", {}), translate("posGatewayManipulation-viewModel.error", {}));
        } finally {
            this.isLoading = false;
        }
    }

    back() {
        this.closePopup();
    }

}
